"use strict";
import Api from "../api/api";
import ApiService from "../services/api_service";
import Auth from "../util/auth";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
import carrierInvoiceService from "../services/carrier_invoices_service";
import CarrierService from "../services/carrier_service";
import DataStoreService from "./data_store_service";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import FeaturesService from "./features_service";
import fetch from "../util/fetch";
import LoadDetail from "./indexer/load_detail";
import LoadsService from "./loads_service";
import DocumentBrowserPagination from "../helpers/document_browser_pagination";
import WaitingSpinner from "./waiting_spinner";
import DashboardReturnParams from "./ui/dashboard_return_params";
import { GroupedDocumentBrowserModel, DocumentBatchGroupCreator } from "./grouped_document_browser_model";
import { History } from "react-router";
import _ from "underscore";
import hotkeys from "../util/hotkeys";
import { isLtlReconcileEnabled } from "./ltl/reconcile";
var ConfirmAndSubmitPage = React.createClass({
  mixins: [History],
  getInitialState: function() {
    return {
      loaded: false,
      v3ReskinEnabled: Auth.v3ReskinAuditSettingEnabled(),
      v3ReskinCheckboxVisible: Auth.v3ReskinAuditCheckboxVisible()
    };
  },
  componentWillReceiveProps: function(newProps) {
    this.removeListeners(this.props);
    this.updateData(newProps).then(() => this.addListeners(newProps));
  },
  componentWillMount() {
    $(DataStoreService).on(
      "DataStoreService:documentPageReplaced",
      this.pageReplaced
    );
    $(DataStoreService).on(
      "DataStoreService:documentGroupUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).on(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentBatchUpdated
    );
  },
  componentDidMount: function() {
    this.updateDataCallbackId = 0;
    hotkeys.listenInComponent(this, AccountsPayable, {
      "nextPage": _.partial(this.changePage, "next"),
      "prevPage": _.partial(this.changePage, "previous")
    });
    LoadsService._store.enableNotifications();
    CarrierInvoicesStore.enableNotifications();
    this.updateData(this.props).then(() => this.addListeners(this.props));
  },
  fetchBulkLines(pages) {
    var withoutLines = _.filter(pages, (p) => p && p.id && _.isUndefined(p.lines));
    if (withoutLines.length > 0) {
      return ApiService.addErrorHandler(
        fetch(`/api/document_pages/bulk_lines`, {
          data: {
            ids: _.map(withoutLines, (p) => p.id)
          }
        }).then((response) => {
          _.each(response.bulk_lines, (linesObj) => {
            var page = _.find(withoutLines, (localPage) => localPage.id === linesObj.page_id);
            page.lines = linesObj.lines;
          });
          return null;
        })
      );
    }
  },
  componentWillUnmount: function() {
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.pageReplaced
    );
    $(DataStoreService).off(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.handleDocumentBatchUpdated
    );
    hotkeys.unlistenInComponent(this);
    this.removeListeners(this.props);
    CarrierInvoicesStore.disableNotifications();
    LoadsService._store.disableNotifications();
  },
  addListeners: function(props) {
    $(LoadsService._store).on(
      "storeItemChanged:loadState:" + props.params.loadId,
      this.refresh
    );
    if (props.params.carrierInvoiceId) {
      $(CarrierInvoicesStore).on(
        "storeItemChanged:carrierInvoice:" + props.params.carrierInvoiceId,
        this.refresh
      );
    }
  },
  removeListeners: function(props) {
    $(CarrierInvoicesStore).off(
      "storeItemChanged:carrierInvoice:" + props.params.carrierInvoiceId,
      this.refresh
    );
    $(LoadsService._store).off(
      "storeItemChanged:loadState:" + props.params.loadId,
      this.refresh
    );
  },
  updateData: function(props, pageToSelect) {
    let currentCallbackId = this.updateDataCallbackId + 1;
    this.updateDataCallbackId = currentCallbackId;
    return Promise.all([
      LoadsService.getLoad(props.params.loadId),
      FeaturesService.ready()
    ]).then((values) => {
      var loadState = values[0];
      return this.setLoadDocumentsAvailable(loadState).then(
        this.fetchDocumentBatches(loadState).then((documentBatches) => {
          documentBatches.forEach((db) => DocumentsService.updateDocuments(db.documents));
          var invoiceID = props.params.carrierInvoiceId;
          if (this.wasRedirected(invoiceID, loadState) || currentCallbackId != this.updateDataCallbackId) {
            return;
          }
          invoiceID = parseInt(invoiceID);
          var invoice = carrierInvoiceService.getInvoiceById(invoiceID);
          var documentModel = this.documentModel(
            documentBatches,
            loadState,
            invoiceID,
            pageToSelect
          );
          return CarrierService.carrierService.carrierWithId(
            invoice ? invoice.carrier_id : loadState.load.carrier_id
          ).then((carrier) => {
            if (this.isMounted()) {
              this.setState({ carrier });
            }
            return null;
          }).then(() => {
            if (this.isMounted()) {
              this.setState({
                loadState,
                documentModel,
                documentIndexerService: new DocumentIndexerService(
                  {},
                  DataStoreService,
                  Api.Account,
                  this.props.location
                ),
                carrierInvoice: invoice,
                email: this.findEmail(documentBatches),
                loaded: true
              });
            }
            return null;
          }).then(() => {
            if (this.isMounted()) {
              var docs = this.state.documentModel && this.state.documentModel.activeDocuments();
              if (docs) {
                var pages = _.flatten(_.map(docs, (d) => d.pages));
                return this.fetchBulkLines(pages);
              }
            }
            return null;
          });
        })
      );
    });
  },
  showLoadDocuments: function(loadState) {
    return _.isEmpty(loadState.carrier_invoices) || this.props.location.query.showLoadDocuments;
  },
  refresh: function(data) {
    this.updateData(this.props);
  },
  setLoadDocumentsAvailable: function(loadState) {
    return DocumentsService.getDocuments(loadState.document_ids).then((docs) => {
      if (_.some(docs, (d) => {
        return !d.carrier_invoice_id && !d.factor_invoice_id;
      })) {
        this.setState({ loadDocumentsAvailable: true });
      }
      return Promise.resolve(true);
    });
  },
  fetchDocumentBatches: function(loadState) {
    return DocumentsService.getDocumentBatches(
      loadState.document_batch_ids,
      (db) => false
    );
  },
  wasRedirected: function(invoiceID, loadState) {
    return !this.showLoadDocuments(loadState) && !invoiceID && this.wasAbleToRedirectToFirstInvoice(loadState);
  },
  currentPage: function(pageToSelect) {
    return pageToSelect || (this.state.documentModel ? this.state.documentModel.selectedPage : null);
  },
  documentModel: function(documentBatches, loadState, invoiceID, pageToSelect) {
    var component = this;
    return new GroupedDocumentBrowserModel(
      new DocumentBatchGroupCreator(
        documentBatches,
        function(doc) {
          return component.showDocument(doc, invoiceID, loadState);
        }
      ),
      function() {
        return false;
      },
      this.currentPage(pageToSelect)
    );
  },
  showDocument(doc, invoiceID, loadState) {
    let maybeInvoice = loadState.carrier_invoices.find((invoice) => invoice.id === invoiceID);
    if (this.props.location.query.showLoadDocuments) {
      return loadState.document_ids.includes(doc.id);
    } else if (isLtlReconcileEnabled(maybeInvoice)) {
      return doc.carrier_invoice_id === invoiceID || !doc.carrier_invoice_id && loadState.document_ids.includes(doc.id);
    } else {
      return doc.carrier_invoice_id === invoiceID || _.isEmpty(loadState.carrier_invoices) && loadState.document_ids.includes(doc.id);
    }
  },
  pageReplaced(args, page) {
    if (page) {
      const currentPage = this.state.documentModel && this.state.documentModel.selectedPage;
      const isUpdatedVersionOfCurrentPage = currentPage && currentPage.document_id === page.document_id && currentPage.number === page.number;
      if (isUpdatedVersionOfCurrentPage) {
        this.updateData(this.props, page);
      } else {
        this.updateData(this.props);
      }
    }
  },
  handleDocumentBatchUpdated(event, documentBatch) {
    this.updateData(this.props);
  },
  handleDocumentGroupUpdated(event, documentGroup) {
    this.updateData(this.props);
  },
  wasAbleToRedirectToFirstInvoice: function(loadState) {
    if (loadState.carrier_invoices.length > 0) {
      var invoiceID = parseInt(loadState.carrier_invoices[0].id);
      if (!isNaN(invoiceID)) {
        var baseUrl = this.props.location.pathname + "/carrier_invoices/" + invoiceID;
        if (this.requiresLtlReconciliation(invoiceID)) {
          baseUrl += "/ltl-reconcile";
        }
        this.history.pushState(
          null,
          baseUrl,
          _.extend(
            this.props.location.query,
            DashboardReturnParams(this.props.location)
          )
        );
        return true;
      }
    }
    return false;
  },
  requiresLtlReconciliation: function(invoiceID) {
    var invoice = carrierInvoiceService.getInvoiceById(invoiceID);
    return invoice && invoice.hasOwnProperty("requires_ltl_reconciliation") && invoice.requires_ltl_reconciliation;
  },
  findEmail: function(documentBatches) {
    var emailID = this.props.location.query["emailMessageId"];
    if (emailID) {
      return _.findWhere(_.pluck(documentBatches, "email_message"), { id: parseInt(emailID) });
    }
    return _.first(_.compact(_.pluck(documentBatches, "email_message")));
  },
  // RENDERING
  changePage(direction, event) {
    DocumentBrowserPagination.changePage(
      this.state.documentModel,
      direction,
      event
    );
    this.forceUpdate();
  },
  completionContext: function() {
    if (this.props.location.query["hasMore"] === "true") {
      return "and continue to the next Group";
    } else {
      return "and return to the Dashboard";
    }
  },
  toggleDocumentsCallback: function() {
    this.forceUpdate();
  },
  content: function() {
    if (this.state.loaded) {
      const loadState = this.state.loadState;
      return (
        // this.state.documentModel must exist because this.state.loaded is only true once it's been set.
        /* @__PURE__ */ React.createElement(
          LoadDetail,
          {
            ref: "loadDetail",
            toggleDocumentsCallback: this.toggleDocumentsCallback,
            loadDocumentsAvailable: this.state.loadDocumentsAvailable,
            model: this.state.documentModel,
            load: loadState,
            carrierInvoice: this.state.carrierInvoice,
            carrier: this.state.carrier,
            documentIndexerService: this.state.documentIndexerService,
            email: this.state.email,
            completionContext: this.completionContext(),
            location: this.props.location,
            refresh: this.refresh,
            allowsEditing: true,
            v3ReskinEnabled: this.state.v3ReskinEnabled
          }
        )
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  },
  render: function() {
    const checkbox = this.state.v3ReskinCheckboxVisible ? this.v3ReskinCheckbox() : null;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(WaitingSpinner, { when: !this.loaded }, this.content()), checkbox);
  },
  v3ReskinCheckbox: function() {
    return /* @__PURE__ */ React.createElement("label", { style: {
      position: "fixed",
      padding: "10px",
      background: "#fffa",
      backdropFilter: "blur(4px)",
      border: "1px solid black",
      borderTopRightRadius: "8px",
      bottom: "-1px",
      left: "-1px",
      display: "flex",
      gap: "8px",
      zIndex: 10
    } }, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "checkbox",
        style: { margin: 0, outline: 0 },
        onChange: () => {
          const newEnabled = !this.state.v3ReskinEnabled;
          this.setState({ v3ReskinEnabled: newEnabled });
          this.refs.loadDetail.setState({ v3ReskinEnabled: newEnabled });
        },
        checked: this.state.v3ReskinEnabled
      }
    ), "V3 Reskin Audit");
  }
});
export default ConfirmAndSubmitPage;
